<template>
    <div>
      <el-dialog
        id="linePopup"
        :visible.sync="showlinePopup"
        width="30%"
        center
        :append-to-body="true"
      >
        <h3 style="text-align: center; margin-bottom: 20px">线路切换</h3>
        <el-divider></el-divider>
        <div>
          <el-row :gutter="20">
            <!-- <el-col :span="12" style="text-align: center">{{item.name}}</el-col>
            <el-col :span="12" style="text-align: center"
              ><el-radio v-model="radio"></el-radio
            ></el-col> -->
            <el-radio-group
              v-model="radio"
              style="display: flex; justify-content: center"
            >
              <el-radio
                :label="item.id"
                v-for="(item, index) in lineTypes"
                :key="index"
                >{{ item.name }}</el-radio
              >
            </el-radio-group>
          </el-row>
          <el-divider></el-divider>
        </div>
        <el-row>
          <el-col :span="12" style="text-align: center"
            ><el-button
              type="primary"
              plain
              @click="cancelLines"
              style="width: 65%"
              >取消</el-button
            ></el-col
          >
          <el-col :span="12" style="text-align: center"
            ><el-button
              type="primary"
              plain
              @click="ChangeLine"
              style="width: 65%"
              >确定</el-button
            ></el-col
          >
        </el-row>
      </el-dialog>
    </div>
  </template>
  <script>
  import $ from "jquery";
  export default {
    name: "linePopup",
    components: {},
    data() {
      return {
        showlinePopup: false,
        radio: parseInt(localStorage.getItem("lineUrlId")),
        lineTypes: this.$URLs,
        urlBaseId: localStorage.getItem("lineUrlId"),
      };
    },
    mounted: function () {
    },
    methods: {
      showlineListPopup() {
        this.showlinePopup = true;
      },
      hidelineListPopup() {
        this.showlinePopup = false;
      },
      ChangeLine() {
        let item = this.lineTypes.find((i) => i.id == this.radio);
        if (item) {
          let lineUrl = item.url;
          let lineUrlText = item.name;
          let lineUrlId = item.id;
          localStorage.setItem("lineUrl", lineUrl);
          localStorage.setItem("lineUrlText", lineUrlText);
          localStorage.setItem("lineUrlId", lineUrlId);
          this.radio = lineUrlId;
          this.showlinePopup = false;
          location.reload();
        }
      },
      cancelLines() {
        this.showlinePopup = false;
      },
    },
  };
  </script>
  <style>
  #linePopup .el-dialog__headerbtn .el-dialog__close {
    display: none;
  }
  
  #linePopup .el-dialog__header {
    display: none;
  }
  
  #linePopup .el-dialog {
    border-radius: 15px;
  }
  
  #linePopup .el-dialog__body {
    padding: 25px 25px 30px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/common/linepopup.vue